// HEIGHT ADAPT +++++++++++++++++++++++++
$(function () {

    // // 表示限界期限
    // const limitDate = new Date(2027, 7, 16);
    // // 現在の日付
    // const currentDate = new Date();
    // // new-iconのdom
    // let newIconContent = document.getElementById("js-limit-new");
    // // 3ヶ月が経過していない場合は表示
    // if (currentDate < limitDate) {
    //     newIconContent.style.display = "block";
    // }

    // $.fn.matchHeight._afterUpdate = function (load) {
    //     $(".layout").matchHeight();
    // }
});


